const socialMedia = {
    instagram: 'Instagram',
    behance: 'Behance',
    linkedin: 'LinkedIn',
    mail: 'Envoyez moi un email',
}

export default socialMedia
